import axios from 'axios';
import { BASE_URL } from '@/constants/api/urls';

const axiosJWT = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

export default axiosJWT;
